// extracted by mini-css-extract-plugin
module.exports = {"slider":"ThreeDViewer_slider__3GxRj","selectedFeatureDetailsContainer":"ThreeDViewer_selectedFeatureDetailsContainer__1PHTg"};